import { Component, OnInit } from '@angular/core';
import { AuthServiceService } from 'src/app/services/auth-service.service';
import { RestService } from 'src/app/services/rest.service';
import { IDropdownSettings, } from 'ng-multiselect-dropdown';
import { CommonServiceService } from 'src/app/services/common-service.service';

@Component({
  selector: 'app-sales-analytics',
  templateUrl: './sales-analytics.component.html',
  styleUrls: ['./sales-analytics.component.scss']
})
export class SalesAnalyticsComponent implements OnInit {
  salesArray: any = [];
  userInfo: any;
  filters = {
    ventureId: 'all',
    plotStatus: 'all',
    fromDate: null,
    toDate: null
  };
  ventures: any = [];
  dropdownSettings:IDropdownSettings={};
  selectedItems = [];

  constructor(
    private restService: RestService,
    public commonService: CommonServiceService,
    private authService: AuthServiceService
  ) { }

  ngOnInit(): void {
    this.userInfo = this.authService.getUserInfo();
    let path:any;
    if(this.userInfo.scopes.includes('TENANT_PRIVILEGE') || this.userInfo.scopes.includes('TENANT_BASIC_PRIVILEGE')) {
      path = 'tenant/venture/getVenturesList';
      this.dropdownSettings = {
        idField: 'ventureId',
        textField: 'ventureName',
      };         
    } else if(this.userInfo.scopes.includes('MARKETER_SUPER_PRIVILEGE') || this.userInfo.scopes.includes('MARKETER_BASIC_PRIVILEGE')) {
      path = 'marketer/venture/getVenturesList';
      this.dropdownSettings = {
        idField: 'ventureId',
        textField: 'displayName',
      };   
    }
    this.restService.submitGetRequest(path).subscribe(response => {
      this.ventures = response.data;
    });
  }

  getPerformances() {
    let url;
    this.filters.ventureId = this.selectedItems.toString();
    let venture = (this.filters.ventureId != 'all' && this.filters.ventureId != null) ? '&ventureIdList='+this.filters.ventureId :'';
    let plotStatus = (this.filters.plotStatus != 'all' && this.filters.plotStatus != null) ? '&plotStatus='+this.filters.plotStatus:'';
    let fromDate = this.filters.fromDate?'&fromDate='+this.filters.fromDate:'';
    let toDate = this.filters.toDate?'&toDate='+this.filters.toDate:'';
    if(this.userInfo.scopes.includes('TENANT_PRIVILEGE') || this.userInfo.scopes.includes('TENANT_BASIC_PRIVILEGE')) {      
      url = 'tenant/sales/analytics?' + 'tenantId='+this.userInfo.tenantId+venture+plotStatus+fromDate+toDate;
    } else if(this.userInfo.scopes.includes('MARKETER_SUPER_PRIVILEGE') || this.userInfo.scopes.includes('MARKETER_BASIC_PRIVILEGE')) {
      url = 'marketer/sales/analytics?' + 'marketerId='+this.userInfo.marketerId+venture+plotStatus+fromDate+toDate;
    }
    this.restService.getSales(url).subscribe(response => {
      if (response.data != null && response.data != undefined) {
        this.salesArray = response.data;
      }
    },
    (error) => {
      console.log(error.status);
    });
  }
  
  onItemSelect(item: any) {
    this.selectedItems.push(item.ventureId)
  }

  onItemDeSelect(item: any) {
    this.selectedItems = this.selectedItems.filter(ele => {
      return ele != item.ventureId
    });
  }

  onSelectAll(items: any) {
    this.selectedItems = [];
    this.ventures.forEach(element => {
      this.selectedItems.push(element.ventureId)
    });
  }
  
  onUnSelectAll() {
    this.selectedItems = []
  }
}
